<template>
  <div class="exam-records">
    <van-dialog ref="dialog"
                v-if="isShow"
                @close="isShow = false"
                :is-disable-close="true"
                :is-show-footer="false">
      <template slot="title">
        <van-quizzes-toolbar :title="examType" :is-forced="false" @close="close" />
      </template>
      <template v-if="type === 'section'">
        <div class="description">同样的知识点，不一样的学习内容，点击下方按钮开始学习吧！</div>
        <el-table header-row-class-name="van-table-header"
                  row-class-name="van-table-row"
                  height="410"
                  :data="examRecords">
          <el-table-column class-name="van-table-item" prop="name" label="同步练习" />
          <el-table-column
              class-name="van-table-item"
              fixed="right"
              label="操作"
              width="100">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="review(scope.row.id, 'section')">开始练习</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-else-if="type === 'chapter'">
        <div class="description">同样的知识点，不一样的学习内容，点击下方按钮开始学习吧！</div>
        <el-table header-row-class-name="van-table-header"
                  row-class-name="van-table-row"
                  height="410"
                  :data="examRecords">
          <el-table-column class-name="van-table-item" prop="name" label="章考试" />
          <el-table-column class-name="van-table-item"
                          align="center"
                          label="最近考试日期"
                          width="120">
            <template slot-scope="scope">
              <span class="test" v-if="scope.row.updatedAt !== '' ">{{scope.row.updatedAt}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column class-name="van-table-item"
                          header-align="center"
                          align="center"
                          label="耗时"
                          width="100">
            <template slot-scope="scope">
              <span class="test" v-if="scope.row.spendTime !== '' ">{{scope.row.spendTime}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column class-name="van-table-item"
                          header-align="center"
                          align="center"
                          label="成绩"
                          width="100">
            <template slot-scope="scope">
              <span class="test" v-if="scope.row.score !== -1 ">{{scope.row.score}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
              class-name="van-table-item"
              fixed="right"
              label="操作"
              width="100">
            <template v-if="type === 'chapter'" slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="review(scope.row.id, 'chapter')">开始考试</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-else>
        <p>已经考过的试卷，再点击“开始考试”可以刷新成绩，仅记录最后一次考试的成绩；“查看报告”可以查看上一次答卷的情况</p>
        <el-form inline>
          <el-form-item label="地区">
            <el-input v-model="query" placeholder="请输入地区查询试卷" size="small"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="getExamRecords()">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table header-row-class-name="van-table-header"
                  row-class-name="van-table-row"
                  height="410"
                  :data="examRecords">
          <el-table-column class-name="van-table-item" prop="name" label="真题试卷" />
          <el-table-column class-name="van-table-item"
                          align="center"
                          label="最近考试日期"
                          width="120">
            <template slot-scope="scope">
              <span class="test" v-if="scope.row.updatedAt !== '' ">{{scope.row.updatedAt}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column class-name="van-table-item"
                          header-align="center"
                          align="center"
                          label="耗时"
                          width="100">
            <template slot-scope="scope">
              <span class="test" v-if="scope.row.spendTime !== '' ">{{scope.row.spendTime}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column class-name="van-table-item"
                          header-align="center"
                          align="center"
                          label="成绩"
                          width="100">
            <template slot-scope="scope">
              <span class="test" v-if="scope.row.score !== -1 ">{{scope.row.score}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
              class-name="van-table-item"
              fixed="right"
              label="操作"
              width="200">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="review(scope.row.id, 'exam', 'examination')">开始考试</el-button>
              <el-button
                type="text"
                size="small"
                @click="report(scope.row)"
                class="report-entry"
                :class="{'has-reports': scope.row.score !== -1 }"
              >查看报告</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <van-pagination
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="total"
        :current-page="page"
        @current-change="getExamRecords"
      ></van-pagination>
    </van-dialog>
  </div>
</template>

<script>
import {
  Table, TableColumn, Pagination, Form, FormItem, Input, Button,
} from 'element-ui';
import VanDialog from '@/components/common/Dialog.vue';
import VanQuizzesToolbar from '@/components/quizzes/QuizzesToolbar.vue';
import api from '@/api/graphql/learning';

export default {
  components: {
    ElTable: Table,
    ElTableColumn: TableColumn,
    ElForm: Form,
    ElFormItem: FormItem,
    ElInput: Input,
    ElButton: Button,
    VanDialog,
    VanQuizzesToolbar,
    VanPagination: Pagination,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      total: 0,
      examRecords: [],
      sectionId: 0,
      type: '',
      page: 1,
      pageSize: 10,
      isShow: false,
      query: '',
    };
  },
  computed: {
    courseId() {
      return Number(this.$route.params.courseId) || 0;
    },
    examType() {
      if (this.type === 'mock') {
        return `${this.title}-真题目录`;
      }
      if (this.type === 'section') {
        return `${this.title}-同步练习目录`;
      }
      if (this.type === 'chapter') {
        return `${this.title}-章考试目录`;
      }
      return '考试记录';
    },
    labelName() {
      if (this.type === 'section') {
        return '同步练习';
      }
      if (this.type === 'chatper') {
        return '章考试';
      }
      return '真题试卷';
    },
  },
  methods: {
    open(type, id) {
      this.isShow = true;
      this.type = type;
      this.page = 1;
      this.query = '';
      if (type === 'section' || type === 'chapter') {
        this.sectionId = id;
      }
      // this.update(id);
      api.getCourseExamRecords({
        courseId: this.courseId,
        sectionId: id,
        page: 1,
        type: this.type,
        name: this.query,
      }).then((data) => {
        this.examRecords = data.courseExamRecords.list;
        this.total = data.courseExamRecords.total;
        this.$refs.dialog.open();
      });
    },
    close() {
      this.$emit('closeExamList');
      this.$refs.dialog.close();
    },
    update(id) {
      this.getExamRecords(this.page, id);
    },
    getExamRecords(page = 1) {
      api.getCourseExamRecords({
        courseId: this.courseId,
        sectionId: this.sectionId,
        page,
        type: this.type,
        name: this.query,
      }).then((data) => {
        this.examRecords = data.courseExamRecords.list;
        this.total = data.courseExamRecords.total;
        this.page = page;
      });
    },
    review(id, type, action) {
      this.$emit('review', {
        type,
        action,
        id,
      });
    },
    report({ id, score }) {
      if (score === -1) return;
      this.$emit('record', {
        type: 'exam',
        action: 'report',
        id,
        score,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .exam-records {
    p {
      margin-top: 0;
    }
    .description {
      margin: 5px 0;
    }
    /deep/ .el-table {
      .van-table-header {
        color: #fff;
        .van-table-item {
          background-color: $primary;
        }
      }
      .van-table-row {
        .van-table-item {
          padding: 5px 0;
          border: 0;
          .report-entry {
            margin-left: 20px;
            color: $border-color;
          }
          .has-reports {
            color: $primary;
          }
        }
      }
      &:before {
        height: 0;
      }
      .el-table__fixed-right {
        &:before {
          height: 0;
        }
      }
    }
    .el-pagination {
      margin: 15px 0 0 0;
      text-align: right;
    }
  }
</style>
